module.exports = __webpack_public_path__ + "static/media/10.e2a9c352.wav";